// Links para o endereço antigo da loja (loja.persimateriais.com.br, o
// WordPress/WooCommerce) dentro de textos vindos do catálogo e do WordPress
// (descrições de produto, categoria, marca, páginas e posts) passam a
// apontar para o site principal com o mesmo caminho: as URLs de categoria
// (/hidraulica/pex/) e de produto (/<slug>/) são as mesmas nos dois sites
// (2026-10-24, pedido do dono).
//
// Só reescreve href de links de página. Arquivos e rotas do WordPress
// (/wp-content/ imagens, /wp-json/, /wp-admin/, /wp-includes/, /wp-login.php)
// continuam no endereço da loja, onde existem. Puro, testado em
// tests/legacyStoreLinks.test.mjs.

export const LEGACY_STORE_HOST = "loja.persimateriais.com.br";
export const MAIN_SITE_ORIGIN = "https://persimateriais.com.br";

const WORDPRESS_ONLY_PATH = /^\/(?:wp-content|wp-json|wp-admin|wp-includes)(?:\/|$)|^\/wp-login\.php/i;

/** Um href: devolve o novo endereço, ou o mesmo valor quando não é link de página da loja antiga. */
export function rewriteLegacyStoreHref(href: string): string {
  const match = /^(?:https?:)?\/\/loja\.persimateriais\.com\.br(?::\d+)?(\/[^\s]*)?$/i.exec(href.trim());
  if (!match) return href;
  const path = match[1] ?? "/";
  if (WORDPRESS_ONLY_PATH.test(path)) return href;
  return `${MAIN_SITE_ORIGIN}${path}`;
}

/** Reescreve os atributos href="..." de um HTML (aspas simples ou duplas). */
export function rewriteLegacyStoreLinks(html: string): string {
  if (!html || !/loja\.persimateriais\.com\.br/i.test(html)) return html;
  return html.replace(/(\bhref\s*=\s*)(["'])([^"']*)\2/gi, (whole, prefix: string, quote: string, value: string) => {
    const next = rewriteLegacyStoreHref(value);
    return next === value ? whole : `${prefix}${quote}${next}${quote}`;
  });
}
